import React, { Component } from 'react';
import Grid from "@mui/material/Grid";
import Switch from '../../../components/Switch.js';
import Bubble from '../../../components/Bubble.js';
import BubbleSelectBlock from '../../../components/BubbleSelectBlock.js';
import NumberInput from '../../../components/TextFields/NumberInput.js';
import Text from '../../../components/Text.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import BlockContent from '../../../components/BlockContent.js';
import HeaderDiv from '../../../components/HeaderDiv.js';
import { colors } from '../../../theme/index.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
import * as localizationMaps from '../../../localization/maps.js';
import { earlyPaymentPrivilegeOptions } from '../../../services/selectFieldOptions.js';
class LifeInsurance extends Component {
  state = {
    data: null
  };
  componentDidMount() {
    const defaults = this._setData(this.props.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      // tier, tierBenefit, benefit, data

      // save the init data in global state so it's there for the save
      this.props.saveModularBenefitInitData(this.props.classID, null, null, 'lifeInsurance', defaults);
      return;
    }

    // save the init data in global state so it's there for the save
    this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'lifeInsurance', defaults);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const defaults = this._setData(nextProps.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      return;
    }
    if (nextProps.selectedDesignID !== this.props.selectedDesignID) {
      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, nextProps.selectedDesignID, 'lifeInsurance', defaults);
    }
  }
  _setData = data => {
    /*
     * we want to set the early payment privilege to true for new plan designs, but false for existing plan designs
     * the earlyPaymentPrivilege field will be undefined for existing plan designs so we can check if the object is empty to
     * determine if the plan design is new
     */
    const isEmpty = Object.keys(data).length === 0;
    const defaults = {
      isSelected: data.isSelected || false,
      isFlatAmount: data.isFlatAmount === undefined ? true : data.isFlatAmount,
      isTimesEarnings: data.isTimesEarnings || false,
      flatAmount: typeof data.flatAmount === "number" ? data.flatAmount : 0,
      timesEarnings: typeof data.timesEarnings === "number" ? data.timesEarnings : 1,
      maxNoEvidence: typeof data.maxNoEvidence === "number" ? data.maxNoEvidence : 0,
      maxEvidence: typeof data.maxEvidence === "number" ? data.maxEvidence : 0,
      reducesBy: typeof data.reducesBy === "number" ? data.reducesBy : 50,
      reducesAtAge: typeof data.reducesAtAge === "number" ? data.reducesAtAge : 70,
      furtherReducesBy: typeof data.reducesBy === "number" ? data.furtherReducesBy : 30,
      furtherReductionAge: typeof data.reducesAtAge === "number" ? data.furtherReductionAge : 85,
      includeSecondReduction: data.includeSecondReduction === undefined ? false : data.includeSecondReduction,
      earlyPaymentPrivilege: isEmpty ? true : Boolean(data.earlyPaymentPrivilege),
      earlyPaymentPrivilegeType: data.earlyPaymentPrivilegeType || "Early Payment Privilege: Equal to the lesser of $50,000 or 50% of the Plan Member Life Amount coverage",
      minVolume: typeof data.minVolume === 'number' ? data.minVolume : 0,
      includeMinVolume: data.includeMinVolume === undefined ? false : data.includeMinVolume,
      terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
      eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
      minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
      notes: data.notes || null
    };
    this.setState({
      data: {
        ...defaults
      }
    });
    return defaults;
  };
  _handleChange = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    this.setState({
      data: {
        ...this.state.data,
        [field]: value
      }
    });
  };
  _saveInGlobalState = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (field === 'notes' && value.toString().length === 0) {
      value = null;
    }
    if (this.props.type === "modular") {
      this.props.saveModularField(this.props.classID, null, null, 'lifeInsurance', field, value);
    } else {
      this.props.savePlanDesignField(this.props.selectedClassID, this.props.selectedDesignID, 'lifeInsurance', field, value);
    }
    this.props.setChangesMadeFlag();
  };
  render() {
    if (!this.state.data) {
      return null;
    }
    const {
      errors,
      whitelabel,
      isMasterSite,
      revision,
      isRevisionBlock
    } = this.props;
    const data = this.state.data;
    const isSelected = Boolean(data.isSelected);
    return /*#__PURE__*/React.createElement(BlockContent, {
      style: isRevisionBlock ? {
        backgroundColor: '#F7F9FA'
      } : null
    }, /*#__PURE__*/React.createElement(HeaderDiv, {
      style: {
        borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
      }
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, revision ? isRevisionBlock ? `${i18n.t(tokens.titles.lifeInsurance)} (${revision.revisionID})` : i18n.t(tokens.labels.planDesign.lifeInsuranceCurrent) : i18n.t(tokens.titles.lifeInsurance)), /*#__PURE__*/React.createElement(Switch, {
      checked: data.isSelected,
      onChange: () => this._saveInGlobalState("isSelected", !isSelected)
    })), isSelected && /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20,
        paddingBottom: 50
      }
    }, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectBetween)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.planDesign.flatAmount),
        selected: data.isFlatAmount,
        field: 'isFlatAmount'
      },
      second: {
        title: i18n.t(tokens.labels.planDesign.timesEarnings),
        selected: data.isTimesEarnings,
        field: 'isTimesEarnings'
      },
      handleChange: this._saveInGlobalState
    }), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, data.isFlatAmount && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.flatAmount),
      fullWidth: true,
      prefix: "$ ",
      value: data.flatAmount,
      onChange: e => this._handleChange("flatAmount", e.target.value),
      onBlur: e => this._saveInGlobalState("flatAmount", e.target.value),
      error: errors.flatAmount,
      variant: "outlined"
    })), data.isTimesEarnings && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.timesEarnings),
      fullWidth: true,
      value: data.timesEarnings,
      variant: "outlined",
      error: errors.timesEarnings,
      onChange: e => this._handleChange("timesEarnings", e.target.value),
      onBlur: e => this._saveInGlobalState("timesEarnings", e.target.value),
      select: true,
      selectOptions: [{
        key: 0,
        value: 1
      }, {
        key: 1,
        value: 1.5
      }, {
        key: 2,
        value: 2
      }, {
        key: 3,
        value: 2.5
      }, {
        key: 4,
        value: 3
      }]
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.nonEvidenceMaximum),
      fullWidth: true,
      prefix: "$ ",
      disabled: !isMasterSite,
      value: data.maxNoEvidence,
      onChange: e => this._handleChange("maxNoEvidence", e.target.value),
      onBlur: e => this._saveInGlobalState("maxNoEvidence", e.target.value),
      error: errors.maxNoEvidence,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.maximumWithEvidence),
      fullWidth: true,
      prefix: "$ ",
      disabled: !isMasterSite,
      value: data.maxEvidence,
      onChange: e => this._handleChange("maxEvidence", e.target.value),
      onBlur: e => this._saveInGlobalState("maxEvidence", e.target.value),
      error: errors.maxEvidence,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reducesBy),
      fullWidth: true,
      suffix: "%",
      value: data.reducesBy,
      onChange: e => this._handleChange("reducesBy", e.target.value),
      onBlur: e => this._saveInGlobalState("reducesBy", e.target.value),
      error: errors.reducesBy,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reducesAtAge),
      fullWidth: true,
      value: data.reducesAtAge,
      onChange: e => this._handleChange("reducesAtAge", e.target.value),
      onBlur: e => this._saveInGlobalState("reducesAtAge", e.target.value),
      error: errors.reducesAtAge,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeSecondReduction)), /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.secondReduction),
      isSelected: data.includeSecondReduction,
      onClick: () => this._saveInGlobalState("includeSecondReduction", !data.includeSecondReduction),
      customStyle: {
        marginBottom: "10px"
      }
    }), data.includeSecondReduction && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.secondReductionBy),
      fullWidth: true,
      suffix: "%",
      value: data.furtherReducesBy,
      onChange: e => this._handleChange("furtherReducesBy", e.target.value),
      onBlur: e => this._saveInGlobalState("furtherReducesBy", e.target.value),
      error: errors.furtherReducesBy,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.secondReductionAtAge),
      fullWidth: true,
      value: data.furtherReductionAge,
      onChange: e => this._handleChange("furtherReductionAge", e.target.value),
      onBlur: e => this._saveInGlobalState("furtherReductionAge", e.target.value),
      error: errors.furtherReductionAge,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.earlyPaymentPrivilege),
      isSelected: Boolean(data.earlyPaymentPrivilege),
      onClick: () => this._saveInGlobalState("earlyPaymentPrivilege", !data.earlyPaymentPrivilege),
      customStyle: {
        marginBottom: "10px"
      }
    })), data.earlyPaymentPrivilege ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.earlyPaymentPrivilegeType),
      value: localizationMaps.fromEnglish("earlyPaymentPrivilegeType", data.earlyPaymentPrivilegeType),
      customStyle: {
        width: "50%"
      },
      variant: "outlined",
      onChange: e => this._handleChange("earlyPaymentPrivilegeType", localizationMaps.toEnglish("earlyPaymentPrivilegeType", e.target.value)),
      onBlur: e => this._saveInGlobalState("earlyPaymentPrivilegeType", localizationMaps.toEnglish("earlyPaymentPrivilegeType", e.target.value)),
      select: true,
      selectOptions: earlyPaymentPrivilegeOptions()
    })) : null, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeMinimumVolume)), /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.minimumVolume),
      isSelected: data.includeMinVolume,
      onClick: () => this._saveInGlobalState("includeMinVolume", !data.includeMinVolume),
      customStyle: {
        marginBottom: "10px"
      }
    }), data.includeMinVolume ? /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.minimumVolume),
      fullWidth: true,
      prefix: "$ ",
      value: data.minVolume,
      variant: "outlined",
      onChange: e => this._handleChange("minVolume", e.target.value),
      onBlur: e => this._saveInGlobalState("minVolume", e.target.value),
      error: errors.minVolume
    }))) : null, /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      margin: "20px 0 10px 0"
    }, i18n.t(tokens.labels.planDesign.planEligibilityTermination)), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.eligibilityPeriodMonths),
      fullWidth: true,
      value: data.eligibilityPeriod,
      variant: "outlined",
      onChange: e => this._handleChange("eligibilityPeriod", e.target.value),
      onBlur: e => this._saveInGlobalState("eligibilityPeriod", e.target.value),
      error: errors.eligibilityPeriod
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.minimumHoursPerWeek),
      fullWidth: true,
      value: data.minHoursPerWeek,
      variant: "outlined",
      onChange: e => this._handleChange("minHoursPerWeek", e.target.value),
      onBlur: e => this._saveInGlobalState("minHoursPerWeek", e.target.value),
      error: errors.minHoursPerWeek
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.terminationAge),
      fullWidth: true,
      value: data.terminationAge,
      onChange: e => this._handleChange("terminationAge", e.target.value),
      onBlur: e => this._saveInGlobalState("terminationAge", e.target.value),
      error: errors.terminationAge,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true
    }, "Notes:"), /*#__PURE__*/React.createElement(TextInput, {
      fullWidth: true,
      value: data.notes || '',
      variant: "outlined",
      error: errors.notes,
      onChange: e => this._handleChange("notes", e.target.value),
      onBlur: e => this._saveInGlobalState("notes", e.target.value),
      multiline: true,
      rows: 5,
      placeholder: i18n.t(tokens.labels.planDesign.additionalRequestsInformation)
    })));
  }
}
export default LifeInsurance;